<script type="text/javascript">
	import Dropdown from "../dropdown.svelte";
	import ProdDropdown from "./productsDropdown.svelte";
	import Icon from "../icon.svelte";
	import Bordered from "../borderedInput.svelte";
	import Checkbox from "../checkbox.svelte";
	import Loader from "../loader.svelte";

	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let api;

	let apiCategory;
	let apiGames;

	let apiGamesSelected; let apiCategorySelected;
	let apiSearch;
	let apiPriceMin; let apiPriceMax;
	let apiSellerVerified; let apiSellerNotVerified;

	export let filter = undefined;
	if (!filter) filter = {
		game: -1, category: null,
		search: "",
		priceMin: -1, priceMax: -1,
		sellerVerified: false, sellerNotVerified: false, sort:"date.desc"
	};
	else{
		api.getGames(c=>{
			c.unshift({id:-1, label:"Выберите игру"});
			apiGames = c;

			apiGamesSelected = apiGames.find(e=>e.id===filter.game);
			api.getCategory(filter.game, c=> {
				c.unshift({id:"", label:"Выберите категорию"});
				apiCategory = c;
				apiCategorySelected = apiCategory.find(e=>e.id===filter.category);
			});
		})
	}
	

	let filterMenuOpened = false;

	

	
	if (!apiGames) api.getGames(c=> {
		c.unshift({id:-1, label:"Выберите игру"});
		apiGames = c;
	});
	if (!apiCategory) api.getCategory(filter.game, c=>apiCategory = c);

	

	function changeApiGames(){
		if (apiGamesSelected){
			if (apiGamesSelected.id) filter.game = apiGamesSelected.id;
			else filter.game = 0;

			apiCategory = [];
			apiCategorySelected = {};

			api.getCategory(filter.game, c=>{
				c.unshift({id:"", label:"Выберите категорию"});
				apiCategory = c;
				apiCategorySelected = c[0];
			});
		}
	} 

	function update(){
		console.log('usr');
		if (apiGamesSelected){
			if (apiGamesSelected.id) filter.game = apiGamesSelected.id;
			else filter.game = 0;
		} else filter.game = 0;
		if (apiCategorySelected){
			if (apiCategorySelected.id) filter.category = apiCategorySelected.id;
			else filter.category = null;
		} else filter.category = null;

		filter.search = apiSearch;
		if (apiPriceMin) filter.priceMin = apiPriceMin;
		else filter.priceMin = 0;
		if (apiPriceMax)  filter.priceMax = apiPriceMax;
		else filter.priceMax = 0;
		filter.sellerVerified = apiSellerVerified;
		filter.sellerNotVerified = apiSellerNotVerified;
		if (apiSortSelected) filter.sort = apiSortSelected.sort;

		dispatch('change', {filter: filter});

	}

	$:{
			}

	let apiSortSelected = {sort: 'date.desc', label:'Дата появления', icon: 'down'};
	let sort = [
		{sort: 'price.asc', label:'Цена', icon: 'up'},
		{sort: 'price.desc', label:'Цена', icon: 'down'},
		{sort: 'date.asc', label:'Дата появления', icon: 'up'},
		{sort: 'date.desc', label:'Дата появления', icon: 'down'},
	]

</script>
<div class="filters-box-fix"></div>
<div class="filters-abs-box">

<div class="filters">
	<div class="categories">
		<div class="category">
			<Dropdown bind:selected={apiGamesSelected} on:change={c=>{changeApiGames(); update();}} values={apiGames}>
				<ProdDropdown bind:selected={apiGamesSelected} label="Выберите игру" />
			</Dropdown>
		</div>
		<div class="category">
			<Dropdown on:change={update} bind:selected={apiCategorySelected} values={apiCategory} >
				<ProdDropdown bind:selected={apiCategorySelected} blue label="Выберите категорию" />
			</Dropdown>
		</div>
	</div>
	<div class="search-button-box">
		<button 
class:app_button-secondary={!filterMenuOpened}
class:app_button-primary={filterMenuOpened}
class="filter-m-button"
on:click={e=>filterMenuOpened=!filterMenuOpened}><Icon filter /> Фильтры</button>
<div class="search">
		<input type="text" class="app_input-transparent" bind:value={apiSearch} placeholder="Введите текст для поиска" on:change={update}>
		<Icon search />
	</div>
	</div>
	
</div>



<div class="filters filters-m" class:show={filterMenuOpened}>
	<div class="filters-m-header">
		<button class="app_button-transparent" on:click={e=>filterMenuOpened=false}>
			<Icon close />
		</button>
	</div>
	<div class="filter">
		<div class="icon"><Icon filter /></div>
		<span>Цена</span>
		<div class="filter-group">
			<div class="filter-box">
				<i>от</i>
				<Bordered>
					<input on:change={update} type="number" min="0" step="1" class="app_input-transparent" style="max-width: 50px;" 
					bind:value={apiPriceMin}>
					<i>&#x20bd;</i>
				</Bordered>
			</div>
			<div class="filter-box">
				<i>до</i>
				<Bordered>
					<input on:change={update} type="number" min="0" step="1" class="app_input-transparent" style="max-width: 50px;"
					bind:value={apiPriceMax}>
					<i>&#x20bd;</i>
				</Bordered>
			</div>
		</div>
	</div>

	<div class="filter">
		<span>Продавцы</span>
		<div class="filter-group">
			<div class="filter-box">
				<Bordered>
					<Checkbox on:change={update} bind:value={apiSellerVerified}>Проверенные</Checkbox>
				</Bordered>
			</div>
			<div class="filter-box">
				<Bordered>
					<Checkbox on:change={update} bind:value={apiSellerNotVerified}>Не проверенные</Checkbox>
				</Bordered>
			</div>
		</div>
	</div>

	<div class="sort">
		<Dropdown on:change={update} bind:selected={apiSortSelected} iconInverse values={sort} >
				<ProdDropdown label="Сортировать" icon="sort" bind:selected={apiSortSelected} grey inverse />
		</Dropdown>
	</div>
</div>

</div>

<style type="text/css">

	.sort{
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	:global(.sort > .dropdown-component){
		width: auto !important;
	}


	.search-button-box{
		display: flex;
	}
	.search-button-box > button{
		margin-right: 15px;
	}
	.filter{
		display: flex;
		align-items: center;
		width: 100%;
	}
	@media(min-width: 1015px){
		.search-button-box > button,
		.filters-m-header{
			display: none;
		}
	}
	@media(max-width: 1015px){
		.filters-m-header{
			display: flex;
			justify-content: flex-end;
			padding-right: 10px;
		}
		.filters-m-header > button{
			padding: 0;
		}
		.filters-m.show{
			display: flex !important;
		}
		.filters-m{
			display: none !important;
			width: auto !important;
			flex-wrap: wrap;
			max-width: 100%;
			position: fixed;
			flex-direction: column;
			background: #0D1219;
			border: 1px solid #25253A;
			box-sizing: border-box;
			padding: 15px 10px !important;
			border-radius: 10px;
		}
		.filter > .filter-group{
			margin-left: 0;
			margin-bottom: 15px;
			flex-wrap: wrap;
		}
		.filter > .icon{
			display: none !important;
		}
		.filter > span{
			margin-top: -11px;
		}
		
	}


	.filter > .filter-group{
		display: flex;
		align-items: center;
		margin-left: 15px;
	}
	.filters:not(:last-child){
		margin-bottom: 50px;
	}

	.filter > .filter-group > .filter-box{
		display: flex;
		align-items: center;
		margin-right: 15px; 
	}

	.filter > .filter-group > .filter-box > i{
		margin-right: 10px;
		color: rgba(255, 255, 255, .5);
		font-weight: 500;
		font-style: normal;
	}
	
	.filter > span{
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		margin-left: 5px;
	}










	.filters{
		display: flex;
		justify-content: flex-start;
	}
	@media(min-width: 1015px){
		.filters > .categories{
			display: flex;
			flex-grow: 1; margin-right: 15px;
		}
		.filters{
			width: 100%; 
		}
		.filters > .categories > .category{width: 100%;}
		.filters > .categories > .category:not(:last-child){margin-right: 15px;}
		.filters > .categories > .category:nth-child(1n){max-width: 250px;}
		.filters > .categories > .category:nth-child(2n){max-width: 540px;}
	}
	@media(max-width: 1015px){
		.filters:first-child{
			flex-direction: column-reverse;
		}
		.filters{
			
			padding: 0;
			width: 100%;
		}
		.filters > .categories{
			display: flex;
			margin-top: 15px;
		}
		.filters > .categories > .category{
			flex-grow: 1;
		}
		.filters > .categories > .category:not(:last-child){
			margin-right: 15px;
		}
			
	}
	.search-button-box{
		flex-grow: 1;
	}
	.search{
		background: #25253A;
		border-radius: 4px;
		color: rgba(255,255,255,.5);
		flex-grow: 1;


		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 15px;
		min-width: 0;
	}
	.search > input{min-width: 0;}
	.search > input::placeholder{
		color: rgba(255,255,255,.5);
	}
	
		
			
	
</style>